import React, {useEffect, useState} from "react";
import {
  ActivityIndicator,
  FlatList,
  TouchableOpacity,
  View,
} from "react-native";
import MultiCard from "../../home/childComponents/multiCard";
import TradeCard from "../../home/childComponents/tradeCard";
import {
  getContestClose,
  getContestEvents,
  getContestLive,
  removeContestProbe,
} from "../redux/contest.action";
import {connect} from "react-redux";
import Colors from "../../../assets/Color/Colors";
import NoMarket from "../../../commonComponents/NoMarkets";
import {globalImport} from "../../../common/globalImports";
import ParentProbeCard from "../../home/childComponents/parentProbeCard";
import Toast from "react-native-toast-message";
import moment from "moment";
import {globalConfigurableData} from "../../../utils/globalConstant";

const ContestEventCards = ({
  navigation,
  eventsData,
  contestEventsLoading,
  getContestEvents,
  contestId,
  isParticipent,
  contestStartTime,
  removeContestProbe,
}) => {
  const [mulitOptionList, setMultiOptionList] = useState([]);

  const onCardClick = item => {
    if (isParticipent) {
      if (moment().unix(new Date()) <= moment.utc(contestStartTime).unix()) {
        Toast.show({
          autoHide: true,
          visibilityTime: 2000,
          position: "bottom",
          type: "success",
          text1: "Contest Event can be traded only after contest start time",
          bottomOffset: 20,
        });
      } else {
        navigation.navigate("ContestEvents", {
          contestId: contestId,
          eventId: item?.id,
          isMulti: item.parent_id === -1 ? true : false,
        });
      }
    } else {
      Toast.show({
        autoHide: true,
        visibilityTime: 2000,
        position: "bottom",
        type: "error",
        text1: "Join contest to trade",
        bottomOffset: 20,
      });
    }
    //navigation.navigate("Event", { eventData: item });
  };

  useEffect(() => {
    PullToRefresh();
  }, []);

  const PullToRefresh = async () => {
    getContestEvents(contestId);
  };

  const timerExpireCallback = item => {
    if (Date.parse(item?.endsat) < Date.now()) {
      removeContestProbe(eventsData, item?.id);
    }
  };

  const renderProbeCard = ({item, index}) => {
    return (
      <TouchableOpacity
        style={{flex: 1}}
        onPress={() => onCardClick(item)}
        delayPressIn={0}
        key={item.id}>
        {item?.parent_id === -1 ? (
          <MultiCard
            trade={item}
            mulitOptionList={mulitOptionList[item.id]}
            isContestCard={true}
            onCallback={() => {
              onCardClick(item);
            }}
            isParticipent={isParticipent}
            contestStartTime={contestStartTime}
            timerExpireCallback={() => {
              timerExpireCallback(item);
            }}
          />
        ) : (
          <ParentProbeCard
            trade={item}
            onCallback={() => {
              onCardClick(item);
            }}
            isContestCard={true}
            isParticipent={isParticipent}
            contestStartTime={contestStartTime}
            timerExpireCallback={() => {
              timerExpireCallback(item);
            }}
          />
        )}
      </TouchableOpacity>
    );
  };

  const handleEmpty = () => {
    return <NoMarket innerContestCondition={true} source="contest_events" />;
  };

  const renderFooter = () => {
    return (
      <View
        style={{
          padding: 10,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
        }}>
        {contestEventsLoading ? (
          <ActivityIndicator size="large" color={globalConfigurableData.loaderColor} />
        ) : null}
      </View>
    );
  };

  useEffect(() => {
    if (eventsData?.probes) {
      const multiOptionFilter = {};
      const filteredProbeList = eventsData?.probes.filter(item => {
        if (item.parent_id >= 1) {
          if (
            multiOptionFilter.length > 0 &&
            multiOptionFilter[item.parent_id]?.length > 0
          ) {
            if (multiOptionFilter[item.parent_id]?.length < 2)
              multiOptionFilter[item.parent_id].push(item);
          } else {
            multiOptionFilter[item.parent_id] = [item];
          }
        }
      });
      setMultiOptionList(multiOptionFilter);
    }
  }, [eventsData]);

  return (
    <View style={{marginTop: -15}}>
      <FlatList
        scrollEnabled={true}
        data={eventsData?.probes}
        renderItem={renderProbeCard}
        keyExtractor={(item, index) => item.id + ""}
        showsVerticalScrollIndicator={false}
        initialNumToRender={10}
        //getItemLayout={getItemLayoutFun}
        updateCellsBatchingPeriod={15}
        //maxToRenderPerBatch={4}

        contentContainerStyle={[
          {
            paddingBottom: eventsData?.probes?.length > 0 ? 350 : 0,
          },
        ]}
        //columnWrapperStyle={{ flex: 1 }}
        ListEmptyComponent={handleEmpty}
        onRefresh={PullToRefresh}
        refreshing={contestEventsLoading}
        ListFooterComponent={globalImport.isWeb ? renderFooter : <></>}
      />
    </View>
  );
};

const mapStateToProps = ({contestLeaderboardReducer}) => ({
  eventsData: contestLeaderboardReducer.eventsData,
  contestEventsLoading: contestLeaderboardReducer.contestEventsLoading,
});
const mapDispatchToProps = {
  getContestEvents,
  removeContestProbe,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContestEventCards);
